import {IconButton} from '@wandb/components';
import React from 'react';

import * as S from './JobDrawerHeader.styles';

interface JobDrawerHeaderProps {
  title: string;
  onClose: () => void;
  showBackButton: boolean;
  onBack?: () => void;
}

export const JobDrawerHeader = ({
  title,
  onClose,
  showBackButton,
  onBack,
}: JobDrawerHeaderProps) => {
  return (
    <S.CenteredFlex>
      {showBackButton && onBack && (
        <S.BackButton>
          <IconButton
            icon="back"
            variant="ghost"
            aria-label="Back"
            onPress={onBack}
            data-test="launch-drawer-back"
          />
        </S.BackButton>
      )}
      <S.Header>{title}</S.Header>
      <S.CloseButton>
        <IconButton
          icon="close"
          variant="ghost"
          aria-label="Close"
          onPress={onClose}
          data-test="launch-drawer-close"
        />
      </S.CloseButton>
    </S.CenteredFlex>
  );
};
